import $ from "jquery";
import "waypoints/lib/jquery.waypoints";
import "waypoints/lib/shortcuts/sticky";

class Section_Nav {
  constructor() {
    let $sectionNav;
    if ($(".section-nav").length) {
      $sectionNav = $(".section-nav");
      if ($sectionNav.length > 0) {
        new Waypoint.Sticky({
          element: $sectionNav,
          offset: "70px"
        });
        $("section.user-icons").waypoint({
          handler: function(e) {
            let current;
            current = $(this).attr("id");
            $(".section-nav .current").removeClass("current");
            return $(`.section-nav a[href="#${current}"]`)
              .parent("li")
              .addClass("current");
          },
          offset: "100px"
        });
        $(".section-nav a").on("click", function({ preventDefault }) {
          let newTop;
          let scrollTop;
          let sectionOffsetTop;
          let target;
          preventDefault;
          scrollTop =
            document.documentElement.scrollTop || document.body.scrollTop;
          if (scrollTop > 453) {
            sectionOffsetTop = 60;
          } else if (scrollTop > 40) {
            sectionOffsetTop = 110;
          } else {
            sectionOffsetTop = 150;
          }
          $(".section-nav .current").removeClass("current");
          $(this)
            .parent("li")
            .addClass("current");
          if (
            location.pathname.replace(/^\//, "") ===
              this.pathname.replace(/^\//, "") &&
            location.hostname === this.hostname
          ) {
            target = $(this.hash);
            target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
            
            if (target.length && target.offset()) {
              newTop = target.offset().top;

              $("html,body").animate(
                {
                  scrollTop: newTop - sectionOffsetTop
                },
                1000
              );
              return false;
            }
          }
        });
      }
    }
  }
}

export default Section_Nav;
